<template>
  <div style="background-color: #fff;">
    <EducationHeader />
    <div class="bannerBox">
      <a-carousel :dot-position="bottom">
        <div>
          <img class="bannerImg" src="@/assets/img/kjrc-rczc.jpg" />
        </div>
      </a-carousel>
    </div>
    <div class="breadBox">
      <a-breadcrumb>
        <span>
          <img src="@/assets/img/position.png" />
          当前位置：
        </span>
        <a-breadcrumb-item>首页</a-breadcrumb-item>
        <a-breadcrumb-item>{{ title }}</a-breadcrumb-item>
      </a-breadcrumb>
    </div>
    <div class="listBigBox">
      <div class="industrialBox">
        <!-- <div class="industrialTitleBox">
          <div class="industrialTitle">
            人才政策
          </div>
        </div> -->
        <div class="recruitmentContentBox">
          <a-list item-layout="vertical" size="large" :pagination="pagination" :data-source="dataSource">
            <template #renderItem="{ item }">
              <div class="listBox" @click="goDetail(item.id)">
                <div class="leftBox">
                  <h1>{{ item.releaseTime && item.releaseTime.split(' ')[0].split('-')[2] }}</h1>
                  <h3>{{ item.releaseTime && item.releaseTime.split(' ')[0].split('-')[0] }}.{{ item.releaseTime &&
                    item.releaseTime.split(' ')[0].split('-')[1] }}</h3>
                </div>
                <div class="right">
                  <div class="title">{{ item.titleName }}</div>
                  <div class="content">{{ item.abstractNote }}</div>
                </div>
              </div>
            </template>
          </a-list>
        </div>
      </div>
    </div>
      <layout-footer/>
  </div>
</template>
<script>
import { getDistMixin, listMixin } from "@/mixins";
import EducationHeader from './educationHeader';
import { homeEducationInfo } from "@/api/educationService";
import LayoutFooter from "@/layout/layoutPage/footer/LayoutFooterNew2.vue";

const pagination = {
  onChange: (page) => {
    console.log(page);
  },
  showQuickJumper: true,
  pageSize: 8,
};
export default {
  name: 'innovationBigData',
  mixins: [getDistMixin, listMixin],
  components: {LayoutFooter, EducationHeader },
  data() {
    return {
      pagination,
      title: '',
      queryParam: {},
      listUrl: homeEducationInfo.talentpolicyList,
      current: 1,
      // pageSize: 10,
    }
  },
  created() {
    this.title = this.$route.query.type
  },
  methods: {
    goDetail(id) {
      this.$router.push({
        path: '/educationService/components/talentpolicyDetail',
        query: { type: '人才政策', id: id }
      })
    }
  }
}
</script>
<style scoped lang="less">
.bannerBox {
  position: relative;
  width: 100%;
  //margin-bottom: 20px;

  .bannerImg {
    width: 100%;
    height: 100%;
  }
}

.breadBox {
  width: 1200px;
  margin: 0 auto;
  padding: 20px 0;
}

.listBigBox {
  width: 1200px;
  margin: 0 auto;

  .industrialBox {
    width: 1200px;
    margin: 0 auto 20px auto;

    .industrialTitleBox {
      overflow: hidden;
      width: 100%;
      padding: 15px 0 8px 0;
      margin-bottom: 10px;
      border-bottom: 1px solid #dedede;

      .industrialTitle {
        float: left;
        font-size: 20px;
        color: #333;
      }

      .industrialTitle::before {
        content: '';
        padding-left: 12px;
        border-left: 4px solid #035aea;
      }

      .MoreBox {
        float: right;
        color: #999;
        font-size: 14px;
        cursor: pointer;
      }
    }

    .recruitmentContentBox {
      padding: 14px 0;
      width: 100%;

      .listBox {
        position: relative;
        overflow: hidden;
        padding: 10px 0;
        cursor: pointer;
        border-bottom: 1px solid #dedede;

        .leftBox {
          float: left;
          width: 150px;
          height: 80px;
          text-align: center;
        }

        .right {
          float: left;
          margin-left: 2%;
          width: 74%;
          font-size: 14px;

          .title {
            padding: 10px 0;
            font-size: 20px;
            color: #333;
            font-weight: 500;
          }

          .content {
            overflow: hidden;
            margin: 10px 0;
            color: #666;
            text-overflow: ellipsis;
            -o-text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
          }
        }
      }
    }

    .pagination {
      text-align: center;
      margin-bottom: 20px;
    }
  }
}
</style>
